import { useTranslation } from "react-i18next";
import {
  Address,
  CommentInfo,
  Defect,
  DefectStatusEntry,
  ImageList,
  PunchlistText,
  StatusEditor,
  StatusHistory,
} from "../..";
import { useEffect, useState } from "react";
import { UserRole } from "imagine-users";
import { Badge, Label } from "imagine-ui";
import { Api } from "imagine-essentials";

interface Props {
  defect: Defect;
  userRole: UserRole;
  onChange?: (defect: Defect) => void;
  onSave?: (status: DefectStatusEntry) => void;
  showStatusHistory?: boolean;
  showType?: boolean;
}

export const DefectInfo = (props: Props) => {
  const { t } = useTranslation();

  const [defect, setDefect] = useState(props.defect);

  useEffect(() => {
    setDefect(props.defect);
  }, [props.defect]);

  const showImageError = (message: string) => {
    console.log("Image upload error occurred", message);
  };

  return (
    <div>
      <h5>
        {defect.projectName}, {defect.addressName}
      </h5>
      <div>
        <h2>{props.defect.title}</h2>
        {props.showType && (
          <div className="mb">
            <Badge color="accent" className="text-md">
              {PunchlistText.getDefectTypeText(defect.type)}
            </Badge>
          </div>
        )}
        <Label>{t("imagine:description")}</Label>
        <p className="mt-none">{props.defect.description}</p>

        <p className="text-italic">
          {t("punchlist:createdBy")}{" "}
          {PunchlistText.getRoleTextNoAdmin(defect.userRole)}
        </p>

        <Label>{t("imagine:status")}</Label>
        <StatusEditor
          defect={defect}
          userRole={props.userRole}
          onSave={props.onSave}
          mode="modal"
        />

        {props.showStatusHistory && (
          <StatusHistory
            history={props.defect.statusHistory || []}
            className="mt d-none--xs"
          />
        )}

        {defect.images && defect.images.length > 0 && (
          <Label className="mt">{t("imagine:images")}</Label>
        )}
        <ImageList
          images={defect.images || []}
          readonly
          url={Api.getHost() + "/upload/defect-images/"}
        />

        {props.defect.comments && props.defect.comments.length > 0 && (
          <>
            <Label className="mt">{t("punchlist:comments")}</Label>
            <div className="column gap-sm">
              {props.defect.comments!.map((comment) => (
                <CommentInfo key={comment.id} comment={comment} />
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
};
